import React from 'react';
import { Link } from 'react-router-dom';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const HeroSection = () => {
  return (
    <section className="min-h-screen bg-gradient-to-br from-background via-muted/20 to-background flex items-center justify-center px-6 py-20">
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-8 items-center">
          {/* Content */}
          <div className="text-center lg:text-left order-2 lg:order-1">
            <div className="inline-flex items-center px-4 py-2 bg-primary/10 text-primary rounded-full text-sm font-medium mb-6">
              <Icon name="Code" size={16} className="mr-2" />
              Available for new opportunities
            </div>
            <h1 className="text-2xl md:text-4xl lg:text-5xl font-bold text-text-primary mb-6 ">
              Senior MERN Stack Developer
              <span className="mt-5 block text-primary text-xl leading-tight">Technical Consultant | Solution Architect</span>
            </h1>
            
            <p className="text-lg md:text-xl text-text-secondary mb-8 max-w-2xl mx-auto lg:mx-0">
              I design and build scalable SaaS applications using the MERN stack while helping businesses transform their ideas into successful digital products. My expertise goes beyond development-I collaborate directly with clients to understand business requirements, architect scalable solutions, lead engineering teams, and deliver production-ready software.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start mb-8">
              <Link to="/projects">
                <Button variant="default" size="lg" rel="noopener noreferrer" iconName="FolderOpen" iconPosition="left" className="w-full sm:w-auto">
                  View My Work
                </Button>
              </Link>
              <Link to="/contact">
                <Button variant="outline" size="lg" iconName="Mail" iconPosition="left" className="w-full sm:w-auto border-2 border-slate-300 dark:border-input">
                  Hire Me as Your Technical Partner
                </Button>
              </Link>
            </div>
            
            {/* Social Links */}
            <div className="flex items-center justify-center lg:justify-start space-x-6">
              <a 
                href="https://github.com/DishantMadariya" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-text-secondary hover:text-primary transition-colors duration-200"
                title="GitHub Profile"
              >
                <Icon name="Github" size={24} />
              </a>
              {/* <a 
                href="https://www.linkedin.com/in/dishantmadariya/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-text-secondary hover:text-primary transition-colors duration-200"
                title="LinkedIn Profile"
              >
                <Icon name="Linkedin" size={24} />
              </a> */}
              <a 
                href="https://twitter.com/dishant_patel14" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-text-secondary hover:text-primary transition-colors duration-200"
                title="Twitter Profile"
              >
                <Icon name="Twitter" size={24} />
              </a>
              <a 
                href="mailto:contact.dishantpatel@gmail.com"
                className="text-text-secondary hover:text-primary transition-colors duration-200"
                title="Email Contact"
              >
                <Icon name="Mail" size={24} />
              </a>
            </div>
          </div>
          
          {/* Professional Headshot */}
          <div className="order-1 lg:order-2 flex justify-center">
            <div className="relative">
              <div className="w-80 h-80 md:w-96 md:h-96 rounded-full overflow-hidden border-4 border-primary/20 shadow-2xl">
                <Image
                  src="/assets/images/IMG_4325.png"
                  alt="Dshant Madariya - Full Stack Developer"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              
              {/* Floating Elements */}
              <div className="absolute -top-4 -right-4 w-16 h-16 bg-primary rounded-full flex items-center justify-center shadow-lg animate-bounce">
                <Icon name="Code2" size={24} color="white" />
              </div>
              
              <div className="absolute -bottom-4 -left-4 w-12 h-12 bg-accent rounded-full flex items-center justify-center shadow-lg animate-pulse">
                <Icon name="Zap" size={20} color="white" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;